/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html} from 'lit';
import styles from './facet-slider-inputs.component.scss?as=stylesheet';
import {createRef, ref} from 'lit/directives/ref.js';
import './facet-slider-input';
import {defineCustomElement} from 'extensions/utils';

class FacetSliderInputs extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			disableFormatOverlay: {
				type: Boolean
			},
			facet: {
				type: String
			},
			format: {
				type: String
			},
			high: {
				type: Number
			},
			label: {
				type: String
			},
			low: {
				type: Number
			},
			step: {
				type: Number
			}
		};
	}

	lowRef = createRef();

	highRef = createRef();

	constructor () {
		super();
		this.step = 1;
	}

	handleSubmit (e) {
		e.preventDefault();

		// Send to handle change event
		this.handleChange(null, null, [
			this.lowRef?.value?.value,
			this.highRef?.value?.value
		]);

		return false;
	}

	render () {
		return html`
			<form class="facet-range-slider--form" @submit="${this.handleSubmit}">
				<rb-facet-slider-input ${ref(this.lowRef)} facet="${this.facet}" max="${this.high - this.step}" label="Min" format="${this.format}" value="${this.low}" ?disableFormatOverlay="${this.disableFormatOverlay}"></rb-facet-slider-input>
				<rb-facet-slider-input ${ref(this.highRef)} facet="${this.facet}" min="${this.low + this.step}" label="Max" format="${this.format}" value="${this.high}" ?disableFormatOverlay="${this.disableFormatOverlay}"></rb-facet-slider-input>
			</form>
		`;
	}
};

defineCustomElement('rb-facet-slider-inputs', FacetSliderInputs);
